import React from 'react';
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { signOut } from "../../../../store/sessionSlice";

import { LogoutOutlined, UserOutlined } from '@ant-design/icons';
import { Popover, Avatar, Button } from 'antd';
import './style.scss';

const ProfileMenu: React.FC = () =>  {
  const dispatch = useAppDispatch();
  const { admin } = useAppSelector(state => state.session);

  const onLogOutClick = () => {
    dispatch(signOut());
  };

  function Menu() {
    const { username, role } = admin;

    return (
      <div className="profile-menu">
        <div className="details-box">
          <div className="img-user">
            <Avatar src={admin.avatar_url} shape="square" size={80} icon={<UserOutlined />} />
          </div>

          <h6>{username}</h6>
          <span>{role || 'Unknown'} Role</span>
        </div>

        <Button className="dropdown-item" onClick={onLogOutClick} type='text'>
          <LogoutOutlined className="item-icon" /> Sign Out
        </Button>
      </div>
    );
  }

  return (
    <Popover overlayClassName='profile-popover' placement="bottomRight"  content={Menu} trigger={'click'}>
      <Avatar src={admin.avatar_url} shape="square" size={32} icon={<UserOutlined />} />
    </Popover>
  );
}

export default ProfileMenu;
